<!--
 * @Author: zhaowh zhaowh@example.com
 * @Date: 2023-09-25 17:24:17
 * @LastEditors: zhaowh zhaowh@example.com
 * @LastEditTime: 2023-11-02 11:14:19
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
      <div>
        <el-form
          ref="filterForm"
          :inline="true"
          :model="filterForm"
          class="filter-form"
        >
          <el-form-item prop="name">
            <el-input
              class="city-select"
              v-model="filterForm.name"
              placeholder="供销社名称"
            ></el-input>
            <!-- <el-autocomplete v-model="filterForm.name" :fetch-suggestions="bankAssociate" placeholder="供销社名称" 
                            label="name" value="value" value-key="name" :trigger-on-focus="false"></el-autocomplete> -->
          </el-form-item>
          <el-form-item prop="userName">
            <el-input
              class="city-select"
              v-model="filterForm.userName"
              placeholder="账号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="contactName">
            <el-input
              class="city-select"
              v-model="filterForm.contactName"
              placeholder="联系人"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item prop="businessZoneId">
                        <el-cascader ref="regionCascader" :options="businessZoneList" :props="zoneProps"
                            v-model="checkedZone" placeholder="服务区域"></el-cascader>
                    </el-form-item> -->
          <el-form-item prop="provinceId" ref="provinceId">
            <el-cascader
              ref="regionCascader"
              :options="regionData"
              :props="regionProps"
              v-model="checkedRegionData"
              @change="handleRegionChange(checkedRegionData)"
              placeholder="服务区域"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleFilter()">查询</el-button>
            <el-button
              type="primary"
              plain
              icon="el-icon-refresh-right"
              @click="handleReset('filterForm')"
            >
              清空
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="main">
      <!--  -->
      <el-table :data="tableData" style="width: 100%; margin-top: 10px">
        <el-table-column label="序号" width="80" align="center">
          <template slot-scope="scope">
            {{
              (pagination.currentPage - 1) * pagination.pageSize +
              (scope.$index + 1)
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="供销社"
          min-width="10%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="commandArea"
          label="管辖地区"
          min-width="10%"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.province }}{{ row.city }}{{ row.county }}
          </template>
        </el-table-column>
        <el-table-column
          prop="userName"
          label="登录账号"
          min-width="10%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="contactName"
          label="联系人"
          min-width="7%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="contactMobile"
          label="登陆手机号"
          min-width="10%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="isEnableName"
          label="状态"
          min-width="5%"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.isEnable == 1 ? "启用" : "禁用" }}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="15%" align="center">
          <template slot-scope="{ row }">
            <el-button
              type="primary"
              plain
              round
              size="small"
              @click="handleInfo(row, 'reset')"
              >重置
            </el-button>
            <el-button
              type="primary"
              plain
              round
              size="small"
              @click="handleInfo(row, 'update')"
              >修改
            </el-button>
            <el-button
              type="primary"
              @click="handleStatus(row, $event)"
              plain
              round
              size="small"
            >
              {{ `${row.isEnable == 0 ? "启用" : "停用"}` }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,prev, pager, next,jumper"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
    <!-- 重置账号弹窗 -->
    <el-dialog
      class="dialog-bg"
      title="重置密码"
      :visible.sync="dialogResetVisible"
      width="550px"
    >
      <el-form
        :model="currentData"
        :rules="resetRules"
        ref="resetForm"
        label-width="100px"
      >
        <el-form-item label="供销社">
          <el-autocomplete
            disabled
            v-model="currentData.name"
            :fetch-suggestions="bankAssociate"
            placeholder="供销社名称"
            label="name"
            value="value"
            value-key="name"
            :trigger-on-focus="false"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="登录账号">
          <el-input disabled v-model="currentData.userName"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="userPassword">
          <el-input
            type="userPassword"
            ref="userPassword"
            auto-complete="new-password"
            autocomplete="off"
            v-model="currentData.userPassword"
            placeholder="请填写新的登录密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogResetVisible = false">取消</el-button>
        <el-button type="primary" @click="handleResetInfo('resetForm')"
          >提交</el-button
        >
      </span>
    </el-dialog>
    <!-- 修改账号弹窗 -->
    <el-dialog
      class="dialog-bg dialog-add"
      title="修改账号"
      :visible.sync="dialogUpdateVisible"
      width="750px"
    >
      <el-form
        :model="currentData"
        :rules="updateRules"
        ref="updateForm"
        label-width="120px"
      >
        <el-form-item label="登录账号">
          <el-input disabled v-model="currentData.userName"></el-input>
        </el-form-item>
        <el-form-item label="供销社" prop="name">
          <el-autocomplete
            v-model="currentData.name"
            :fetch-suggestions="bankAssociate"
            placeholder="供销社名称"
            label="name"
            value="value"
            value-key="name"
            :trigger-on-focus="false"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="姓名" prop="contactName">
          <el-input
            v-model="currentData.contactName"
            placeholder="请填写姓名"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="手机号码"
          class="mobile-form-item"
          prop="contactMobile"
        >
          <el-input
            maxlength="11"
            v-model="currentData.contactMobile"
            placeholder="请填写手机号码"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="登录地址" prop="subDomain" class="sub-domain-item">
                    <div class="login-tip">登录地址2~20位，支持数字和小写字母。</div>
                    <el-input v-model="currentData.subDomain" placeholder="请填写登录地址">
                        <i slot="suffix">
                            -bank
                        </i>
                        <template slot="prepend">http://</template>
                        <template slot="append">.xiangli360.com</template>
                    </el-input>
                </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogUpdateVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSaveInfo('updateForm')"
          >提交</el-button
        >
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
import common from "@/utils/common.js";
import regionSeatLibs from "utils/regionSeatLibs";
let regionData = JSON.parse(JSON.stringify(regionSeatLibs[0].c));

export default {
  name: "SupplyManageList",
  data() {
    return {
      filterForm: {
        name: "",
        contactName: "",
        // businessZoneId: '', //服务区域id
        userName: "",
        // pageType: 5,
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: [],
      businessZoneList: [], //服务区域数据
      zoneProps: {
        value: "id",
        label: "zoneName",
        children: "children",
      },
      checkedZone: [], //选中的服务区域
      dutyPersonList: [],
      dialogResetVisible: false,
      currentData: {},
      resetRules: {
        userPassword: [
          { required: true, message: "请填写6-20位账号密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "请输入6-20位账号密码",
            trigger: "blur",
          },
        ],
      },
      dialogUpdateVisible: false,
      currentCheckedZone: [],
      updateRules: {
        contactName: [
          { required: true, message: "请填写联系人名称", trigger: "blur" },
        ],
        contactMobile: [
          { required: true, message: "请填写手机号码", trigger: "blur" },
          { validator: common.checkMobile, required: true, trigger: "blur" },
        ],
        subDomain: [
          { required: true, message: "请填写登录地址", trigger: "blur" },
          { trigger: "blur", validator: common.checkSubDomain },
          { min: 2, max: 20, message: "长度在4到20位", trigger: "blur" },
        ],
        businessZoneId: [
          { required: true, message: "请选择服务区域", trigger: "blur" },
        ],
      },
      oldRowData: {},
      checkedRegionData: [],
      regionProps: {
        value: "i",
        label: "n",
        children: "c",
      },
      regionData,
    };
  },
  components: {},
  watch: {
    checkedZone(newVal) {
      this.dutyPersonList = [];
      this.filterForm.businessZoneId =
        newVal.length > 0 ? newVal[newVal.length - 1] : "";
      newVal.length > 0 && this.getDutyPerson();
    },
    currentCheckedZone(newVal) {
      this.dutyPersonList = [];
      this.currentData.businessZoneId =
        newVal.length > 0 ? newVal[newVal.length - 1] : "";
      // newVal.length > 0 && this.getCurrentDutyPerson();
    },
  },
  created() {
    this.getBusinessZoneData();
    this.getSupplyMarketList();
  },
  mounted() {},
  methods: {
    // 下拉补贴地区选完关闭
    handleRegionChange(val) {
      this.$refs.regionCascader.dropDownVisible = false;
      let _params = this.filterForm;
      _params.provinceId = val[0] || "";
      _params.cityId = val[1] || "";
      _params.countyId = val[2] || "";
    },
    //页码切换
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getSupplyMarketList();
    },
    /**
     * @Description: 获取系统列表
     * @return {*}
     */
    async getSupplyMarketList() {
      try {
        let { data } = await this.$http.supply.getSupplyMarketList({
          ...this.pagination,
          ...this.filterForm,
        });
        let myData = data.content;
        myData.forEach((item) => {
          if (item.ddCoop !== null) {
            let ddCoop = item.ddCoop;
            item.name = ddCoop.name;
            item.contactName = ddCoop.contactName;
            item.contactMobile = ddCoop.contactMobile;
          }
        });
        this.$set(this, "tableData", myData);
        this.pagination.total = data.recordTotal;
      } catch (error) {
        console.log(error);
      }
    },
    // 获取服务区域数据
    getBusinessZoneData() {
      this.$http.common.getBusinessZoneList({}).then((res) => {
        this.businessZoneList = res.data;
      });
    },
    // 获取业务负责人
    getDutyPerson() {
      this.$http.common
        .getDutyPerson({ businessZoneId: this.filterForm.businessZoneId })
        .then((res) => {
          this.dutyPersonList = res.data;
        });
    },
    // 查询
    handleFilter() {
      this.pagination.currentPage = 1;
      this.getSupplyMarketList();
    },
    //重置
    handleReset(formName) {
      this.$refs[formName].resetFields();
      this.checkedRegionData = [];
      let _filterForm = this.filterForm;
      _filterForm.provinceId = "";
      _filterForm.cityId = "";
      _filterForm.countyId = "";
      setTimeout(() => {
        this.handleFilter();
      }, 500);
    },
    /**
     * @Description: 停用/启用
     * @param {*} handleStatus
     */
    async handleStatus(row, e) {
      let isEnable = row.isEnable == 0 ? 1 : 0;
      let isEnableName = isEnable == 1 ? "启用" : "停用";
      let { id } = row;
      let target = e.target;
      if (target.nodeName == "SPAN") {
        target = e.target.parentNode;
      }
      target.blur();
      if (isEnable == 0) {
        this.$confirm(
          `是否确认${isEnableName}该账号？`,
          `${isEnableName}提示`,
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            this.updateStatus({ userId: id, isEnable });
          })
          .catch(() => {});
      } else {
        this.updateStatus({ userId: id, isEnable });
      }
    },
    /**
     * @Description: 启用停用服务
     * @param {*} params
     */
    async updateStatus(params) {
      try {
        let { status, data } = await this.$http.supply.userEnable(params);
        if (status == 1) {
          this.$message.success(
            params.isEnable == 1 ? "当前账号已启用" : "当前账号已停用"
          );
          this.getSupplyMarketList();
        }
        // else {
        //     this.$message.error(
        //         params.isEnable == 1 ? '当前账号未启用' : '当前账号未停用'
        //     );
        // }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * @Description: 打开弹窗
     * @param {*} row 当前数据
     * @param {*} type 弹窗类型
     * @return {*}
     */
    handleInfo(row, type) {
      this.currentData = JSON.parse(JSON.stringify(row));
      // this.currentData.address = `${row.provinceName}>${row.cityName}>${row.areaName
      //     }`;
      switch (type) {
        case "update":
          // this.getFinanceAccountDetail(
          //     this.currentData.id,
          //     `${row.provinceName}>${row.cityName}>${row.areaName}`
          // );
          this.dialogUpdateVisible = true;
          break;
        case "reset":
          this.dialogResetVisible = true;
          break;
        default:
          break;
      }
    },
    /**
     * @Description: 重置密码
     */
    handleResetInfo(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let { id, userPassword } = this.currentData;
          try {
            let { status } = await this.$http.supply.updatePwd({
              userId: id,
              password: userPassword,
            });
            if (status == 1) {
              this.$message.success("当前账号重置密码成功");
              this.dialogResetVisible = false;
            }
          } catch (error) {
            console.log(error);
          }
        } else {
        }
      });
    },
    /**
     * @Description: 获取账号详情
     */
    async getFinanceAccountDetail(id, address) {
      try {
        let { data } = await this.$http.bank.getFinanceAccountDetail({ id });
        this.currentData = data;
        this.currentData.address = address;
        this.dialogUpdateVisible = true;
      } catch (error) {}
    },
    /**
     * @Description: 保存县账号更新信息
     * @param {*} formName 表单名称
     */
    handleSaveInfo(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let { id, contactMobile, contactName, name } = this.currentData;
          try {
            let { status } = await this.$http.supply.userEdit({
              userId: id,
              phone: contactMobile,
              contactName,
              name,
            });
            if (status == 1) {
              this.$message.success("当前县账号修改成功");
              this.dialogUpdateVisible = false;
              this.getSupplyMarketList();
            }
          } catch (error) {
            console.log(error);
          }
        } else {
        }
      });
    },
    // 供销社
    bankAssociate(key, cb) {
      if (key !== "") {
        this.loading = true;
        this.$http.bank
          .fuzzyQueryList({ key })
          .then(({ data }) => {
            this.loading = false;
            let arr = data.map((item, index) => ({ name: item, value: index }));
            cb(arr); // 渲染回调
          })
          .catch((res) => {
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";

.city-select {
  width: 160px;
}

::v-deep .dialog-bg {
  .el-form {
    .el-form-item {
      margin-bottom: 25px;
      .el-form-item__label {
        width: 120px !important;
      }
      .el-form-item__content {
        margin-left: 120px !important;
      }
      &.sub-domain-item {
        .el-input {
          input {
            text-align: right;
            padding-right: 50px;

            &::-webkit-input-placeholder {
              text-align: left;
            }

            &::-moz-placeholder {
              text-align: left;
            }

            &::-ms-input-placeholder {
              text-align: left;
            }
          }

          .el-input__suffix-inner {
            i {
              display: inline-block;
              height: 100%;
              line-height: 40px;
              color: #606266;
              font-style: inherit;
            }
          }
        }
      }
      &.mobile-form-item {
        margin-bottom: 18px;
      }

      .login-tip {
        height: 34px;
        font-size: 14px;
        color: #acacac;
      }
    }
  }
}
</style>
